import { type IDirectoryModel } from 'tno-core';

export const defaultDirectory: IDirectoryModel = {
  path: '',
  items: [],
  isLocal: false,
};
